import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, Slide } from 'react-toastify';

//3rd party
import Moment from 'react-moment';
import moment from 'moment';
import * as Icon from 'react-bootstrap-icons';
import { Watch } from  'react-loader-spinner';
import Backdrop from '@mui/material/Backdrop';
import Popover from '@mui/material/Popover';

//Functions
import { apiCall, apiError } from '../functions/common';

//Components
import Header from '../components/Header';
import BottomMenu from '../components/BottomMenu';
import Greeting from '../components/Greeting';
import ModalReviewHours from '../components/ModalReviewHours';
import Artwork from '../components/Artwork';
import Button from '../components/Button';
import DayRow from '../components/DayRow';
import DayRowSkeleton from '../components/DayRowSkeleton';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const ReviewRegistrationHours = () => {
    const { t, loading: i18nLoading } = useTranslations();

    const navigate = useNavigate();
    const loggedIn = localStorage.getItem('ingelogd');
    const functie_id = localStorage.getItem('functie_id');
    if(functie_id != 3 && functie_id != 4 && functie_id != 6){ // Voorman, Directie, voorman tekenkamer
        navigate('/');
    }
    const code = global.settings.api.code;

    useEffect(() => {
        if (loggedIn !== 'true') {
            navigate('/login');
        }
        setInterval(() => setDate(new Date()), 30000);
        getRegistrations(1);
    }, []);

    //Variables
    const [date, setDate] = useState(Date.now());
    const [showDate, setShowDate] = useState(moment().format('DD-MM-YYYY'));
    const [submitDate, setSubmitDate] = useState(moment().format('YYYY-MM-DD'));
    const [registerDate, setRegisterDate] = useState(moment().format('YYYY-MM-DD'));
    const [dateLabel, setDateLabel] = useState(moment().format('LL'));
    const [registrationObject, setRegistrationObject] = useState(null);
    const [totals, setTotals] = useState('');
    const [loadingRegistrations, setLoadingRegistrations] = useState(false);
    const [showSkeletonsRegistrations, setShowSkeletonsRegistrations] = useState(true);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [afgeboekt, setAfgeboekt] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const [hours, setHours] = useState(null);
    const [statuses, setStatuses] = useState(null);
    const [statusId, setStatusId] = useState(1);//Loader
    const [statusName, setStatusName] = useState('Pending');//Loader
    //let [reviewArray, setReviewArray] = useState([]);
    const [checkedIds, setCheckedIds] = useState([]);

    //Modal variables
    const [showModal, setShowModal] = useState(0);
    const [modalData, setModalData] = useState([]);

    const [showModalOfferHours, setShowModalOfferHours] = useState(0);
    const [modalDataOfferHours, setModalDataOfferHours] = useState([]);

    //Get user registrations
    const getRegistrations = async (newStatusId = 1, type = null) => {
        setLoadingRegistrations(true);
        if (type === 'skeleton') { setShowSkeletonsRegistrations(true) }
        //setTotals('');
        try {
            const response = await apiCall(`registraties/beoordelen?code=${code}&status_id=${newStatusId}`);
            // Success
            if (response.data.success) {
                const data = response.data.data;
                //console.log(data);
                setHours(data.uren || []);
                setStatuses(data.statussen);
                
                setOpenBackdrop(false);
                setShowModal(false);
                setShowModalOfferHours(false);
                setShowSkeletonsRegistrations(false);
                setLoadingRegistrations(false);
            }
        } catch (error) {
            // Error
            apiError(error);
        }
    }

    /*const handleChangeDate = (value) => {
        setRegisterDate(moment(value.$d).format('YYYY-MM-DD'));
        setDateLabel(moment(value.$d).format('LL'));
        getRegistrations(moment(value.$d).format('YYYY-MM-DD'), 'skeleton');
        setSubmitDate(moment(value.$d).format('YYYY-MM-DD'));
        setShowDate(moment(value.$d).format('DD-MM-YYYY'));
    }*/

    /**/
    const reviewRow = async (ids, status_id) => {
        setOpenBackdrop(true);
        //Call API
        try {
            const response = await apiCall(`registratie/beoordelen?code=${code}&uren_ids=${JSON.stringify(ids)}&status_id=${status_id}`, 'post');

            // Success
            if (response.data.success) {
                //getRegistrations(statusId);
                window.location.reload();
            }
        } catch (error) {
            // Error
            apiError(error);
        }
        setOpenBackdrop(false);
    }

    const renderModal = (uren_ids, status_id) => {
        const obj = {
            uren_ids: uren_ids,
            status_id: status_id
        }
        setModalData(obj);
        setShowModal(showModal + 1);
        //console.log("Show modal");
    }

    const renderOfferHoursModel = (id) => {
        const obj = {
            id: id,
            submitDate: submitDate
        }
        setModalDataOfferHours(obj);
        setShowModalOfferHours(showModalOfferHours + 1);
    }

    const changeStatus = (newStatusId, newStatusName) => {
        //Als je 2x op dezelfde drukt, dan het filter resetten
        if(newStatusId == statusId){
            newStatusId = null;
            newStatusName = null;
        }

        setStatusId(newStatusId);
        setStatusName(newStatusName);
        getRegistrations(newStatusId);
    }

    const checkboxChange = (id, checked) => {
        if(checked){
            setCheckedIds((prevIds) => [...prevIds, id]);
        } else {
            setCheckedIds((prevIds) => prevIds.filter((checkedId) => checkedId !== id));
        }
        /*
        let object = { id: id, uren_id: uren_id }
        console.log(checked);
        if(checked){
            reviewArray.push(object);
            setReviewArray(reviewArray);
        } else {
            let filteredObject = null;
            reviewArray = reviewArray.filter(e => {
                  return uren_id != e.uren_id;
            });
            setReviewArray(reviewArray);
        }
        console.log(reviewArray);*/
    }

    const sendReviews = (status_id) => {
        reviewRow(checkedIds, status_id);
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const parseHours = (row) => parseFloat(row?.aantal_uren?.value ?? 0) || 0;

    const parseDate = (value) => {
        const parsed = moment(value, ['YYYY-MM-DD', 'DD-MM-YYYY'], true);
        return parsed.isValid() ? parsed.valueOf() : 0;
    };

    const formatHours = (value) => (Math.round(value * 100) / 100).toFixed(2);

    const rowsWithGroups = useMemo(() => {
        const sorted = [...(hours || [])].sort((a, b) => {
            const employeeA = (a.medewerker || '').toLowerCase();
            const employeeB = (b.medewerker || '').toLowerCase();
            if(employeeA !== employeeB) return employeeA > employeeB ? 1 : -1;

            const weekA = (a.week_year ?? 0) * 100 + (a.week ?? 0);
            const weekB = (b.week_year ?? 0) * 100 + (b.week ?? 0);
            if(weekA !== weekB) return weekB - weekA;

            const dateA = parseDate(a.datum);
            const dateB = parseDate(b.datum);
            if(dateA !== dateB) return dateB - dateA;

            return (b.uren_id ?? 0) - (a.uren_id ?? 0);
        });

        const employees = new Map();

        sorted.forEach((row) => {
            const employeeKey = row.medewerker || t('unknown_employee', 'Unknown employee');
            const weekKey = `${row.week_year}-${row.week}`;
            const dayKey = row.datum;
            const rowHours = parseHours(row);

            if(!employees.has(employeeKey)){
                employees.set(employeeKey, {
                    employeeName: row.medewerker || t('unknown_employee', 'Unknown employee'),
                    total: 0,
                    weeks: new Map(),
                });
            }

            const employee = employees.get(employeeKey);
            employee.total += rowHours;

            if(!employee.weeks.has(weekKey)){
                employee.weeks.set(weekKey, {
                    weekLabel: row.week_label || `Week ${row.week} (${row.week_year})`,
                    weekYear: row.week_year,
                    week: row.week,
                    total: 0,
                    days: new Map(),
                });
            }

            const week = employee.weeks.get(weekKey);
            week.total += rowHours;

            if(!week.days.has(dayKey)){
                week.days.set(dayKey, {
                    dayLabel: row.datum_nl || row.datum,
                    dateValue: parseDate(row.datum),
                    total: 0,
                    rows: [],
                });
            }

            const day = week.days.get(dayKey);
            day.total += rowHours;
            day.rows.push(row);
        });

        const groupedRows = [];
        let dayStripeIndex = 0;

        employees.forEach((employee, employeeKey) => {
            groupedRows.push({
                __type: 'employee_header',
                __key: `employee-${employeeKey}`,
                label: employee.employeeName,
                totaal_uren: formatHours(employee.total),
            });

            const weekList = Array.from(employee.weeks.entries()).sort((a, b) => {
                const weekA = (a[1].weekYear ?? 0) * 100 + (a[1].week ?? 0);
                const weekB = (b[1].weekYear ?? 0) * 100 + (b[1].week ?? 0);
                return weekB - weekA;
            });

            weekList.forEach(([weekKey, week]) => {
                groupedRows.push({
                    __type: 'week_header',
                    __key: `week-${employeeKey}-${weekKey}`,
                    week_label: week.weekLabel,
                    totaal_uren: formatHours(week.total),
                });

                const dayList = Array.from(week.days.entries()).sort((a, b) => b[1].dateValue - a[1].dateValue);

                dayList.forEach(([dayKey, day]) => {
                    const stripe = dayStripeIndex % 2 === 0 ? 'day-even' : 'day-odd';
                    dayStripeIndex++;

                    groupedRows.push({
                        __type: 'day_header',
                        __key: `day-${employeeKey}-${weekKey}-${dayKey}`,
                        datum_nl: day.dayLabel,
                        totaal_uren: formatHours(day.total),
                        __stripe: stripe,
                    });

                    day.rows.forEach((row) => {
                        groupedRows.push({ ...row, __stripe: stripe });
                    });
                });
            });
        });

        return groupedRows;
    }, [hours, t]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return(
        <div>
            <Header />
            <div className="main">
                <div className="container">
                    <div className="content">
                        <div className="heading">
                            <h1><Greeting /></h1>
                            <span className="time">
                                <Icon.Clock /><Moment format="HH:mm">{date}</Moment>
                            </span>
                        </div>
                        <div className="register">
                            <div className="status-filter">
                                <h2>{t('statuses', 'Statuses')}</h2>
                                {
                                    statuses ?
                                        statuses.map((option, index) => {
                                            return <Button
                                                key={index}
                                                text={option.label}
                                                onClick={() => changeStatus(option.id, option.label)}
                                                style={statusId !== option.id ? {backgroundColor: '#ffffff', border: `1px solid ${option.kleur}`, color: option.kleur } : {backgroundColor: option.kleur, border: `1px solid ${option.kleur}`}}
                                                //active={statusId == option.id ? 1 : 0}
                                            />
                                        })
                                    :
                                    null
                                }
                            </div>
                            
                            {/* Registered hours by day */}
                            <div className="days">
                                <div className="days-heading">
                                    <h3>{t('review_registration_hours', 'Review registration hours')} {statusName ? `- ${statusName}` : null}</h3>
                                    <Icon.ThreeDotsVertical aria-describedby={id} variant="contained" onClick={handleClick} />
                                    <Popover
                                        id={id}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                    >
                                        <span className="option" onClick={() => { sendReviews(0); handleClose(); }}>
                                            <Icon.ArrowRepeat size={17} /> {t('open_hours', 'Open')}
                                        </span>
                                        {statusId !== 2 ?
                                            <span className="option approve" onClick={() => { sendReviews(2); handleClose(); }}>
                                                <Icon.Check size={17} />{t('approve', 'Approve')}
                                            </span>
                                        : null}
                                        {statusId !== 3 ?
                                            <span className="option reject" onClick={() => { renderModal(checkedIds, 3); handleClose(); }}>
                                                <Icon.Trash /> {t('reject', 'Reject')}
                                            </span>
                                        : null}
                                    </Popover>
                                    {
                                        loadingRegistrations ?
                                        <Watch
                                            height="20"
                                            width="20"
                                            radius="48"
                                            color="white"
                                            ariaLabel="watch-loading"
                                            wrapperStyle={{}}
                                            wrapperClassName=""
                                            visible={true}
                                        />
                                        :
                                        null
                                    }
                                </div>
                                <div className="day-rows review-day-rows">
                                    {
                                        showSkeletonsRegistrations ?
                                            <div className="skeletons-hours">
                                                <DayRowSkeleton />
                                                <DayRowSkeleton />
                                                <DayRowSkeleton />
                                            </div>
                                        :
                                            <div>
                                                {hours && hours.length > 0 ?
                                                    rowsWithGroups.map((row) => {
                                                        if(row.__type === 'employee_header'){
                                                            return (
                                                                <div key={row.__key} className="review-group-header review-group-employee">
                                                                    <span>{row.label}</span>
                                                                    <strong>{row.totaal_uren}</strong>
                                                                </div>
                                                            );
                                                        }

                                                        if(row.__type === 'week_header'){
                                                            return (
                                                                <div key={row.__key} className="review-group-header review-group-week">
                                                                    <span>{row.week_label}</span>
                                                                    <strong>{row.totaal_uren}</strong>
                                                                </div>
                                                            );
                                                        }

                                                        if(row.__type === 'day_header'){
                                                            return (
                                                                <div key={row.__key} className="review-group-header review-group-day">
                                                                    <span>{row.datum_nl}</span>
                                                                    <strong>{row.totaal_uren}</strong>
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <DayRow
                                                                key={row.uren_id}
                                                                option={row}
                                                                id={row.registratie_id}
                                                                row_id={row.uren_id}
                                                                showDate={showDate}
                                                                date={row.datum_nl || row.datum}
                                                                aantal_uren={row.aantal_uren}
                                                                dek={row.dekken}
                                                                bouwnummer={row.bouwnummers}
                                                                klant={row.klanten}
                                                                locatie={row.locaties}
                                                                urensoort={row.uren_soorten}
                                                                opmerking={row.opmerking}
                                                                status_opmerking={row.status_opmerking}
                                                                reviewRow={reviewRow}
                                                                renderModal={renderModal}
                                                                medewerker={row.medewerker}
                                                                status={row.status}
                                                                statusId={statusId}
                                                                checkboxChange={checkboxChange}
                                                                review={1}
                                                            />
                                                        );
                                                    })
                                                :
                                                    <p className="no-registrations">{t('no_results', 'No results')}</p>
                                                }
                                            </div>
                                    }
                                </div>
                                {
                                    totals && registrationObject && registrationObject.rijen.length > 0  ?
                                        <div className="day-actions">
                                            <div className="buttons">
                                                {
                                                    afgeboekt ?
                                                    <p>{t('day_closed', 'Day closed')}</p>
                                                    :
                                                    <div>
                                                        {
                                                            totals !== '0.00' ?
                                                            <button className="action-button" onClick={() => renderOfferHoursModel(registrationObject.id)}>
                                                                <span>{t('offer_hours', 'Offer hours')}</span>
                                                            </button>
                                                            :
                                                            null
                                                        }
                                                   
                                                    </div>
                                                }
                                            </div>
                                            <div className="totals">
                                                <p>{totals}</p>
                                                {
                                                    !afgeboekt ?
                                                    <Icon.ThreeDotsVertical />
                                                    :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    :
                                    null
                                }
                            </div>
                            <Artwork />
                        </div>
                    </div>
                </div>
            </div>

            {/* Component bottom menu */}
            <BottomMenu />

            {/* Backdrop */}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop}>
                <Watch
                    height="80"
                    width="80"
                    radius="48"
                    color="white"
                    ariaLabel="watch-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />
            </Backdrop>

            {/* Modal to modify registration line */}
            {
                showModal > 0 ?
                <ModalReviewHours show={showModal} data={modalData} getRegistrations={getRegistrations} />
                :
                null
            }

            <ToastContainer transition={Slide}/>
        </div>
    );
}

export default ReviewRegistrationHours;
